import type { FC } from 'react'
import styled from '@emotion/styled'

import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DemoForm from '@segment/templates/Forms/DemoForm'

import HeroImage from './HeroImage'

const copy = {
  overline: `Unify`,
  heading: `Get a complete view of your customer`,
  description: `Unify real-time customer data interactions with data from your warehouse and empower any team within the business to use trusted data across any platform and channel to build 1:1 personalized experiences at scale.`,
}

const FORM_ID = `profiles-demo-request`

const Hero: FC = () => {
  return (
    <Wrapper>
      <HeroRecipeBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline tag="h5" variant="h5">
              {copy.overline}
            </CopyText.Overline>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <HeroRecipe.Form>
            <DemoForm
              isProgressive={true}
              customFormIdentifier={FORM_ID}
              customTrackingType={FORM_ID}
              successMessageAppearance="twilioLight"
            />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <HeroImage alt={`Illustration: ${copy.heading}`} />
        </HeroRecipe.Contents>
      </HeroRecipeBase>
    </Wrapper>
  )
}

export default Hero

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`
